// The signed-in user, provided by App once /api/me has answered.
//
// Its own module so App and its descendants do not import each other, which would be a cycle the
// moment a route needed to know who the caller is.

import { createContext, useContext } from 'react';

export const MeContext = createContext(null);

export const useMe = () => useContext(MeContext);
